import React, { useState, useEffect } from 'react';
import AOS from 'aos'; // AOS for scroll animations
import 'aos/dist/aos.css'; // AOS styles
import Footer from '../components/Footer';
import Header from '../components/Header';
import Loader from '../components/Loader'; // Import Loader component

const projects = [
  { 
    id: 1, 
    image: '/pexels-500photos-com-15338-93400.jpg', 
    name: 'Skyscraper Development' 
  },
  { 
    id: 2, 
    image: '/pexels-asphotograpy-224924.jpg', 
    name: 'Bridge Construction' 
  },
  { 
    id: 3, 
    image: '/pexels-daniel-12255.jpg', 
    name: 'Residential Housing' 
  },
  { 
    id: 4, 
    image: '/pexels-davidmcbee-392031.jpg', 
    name: 'Highway Expansion' 
  },
  { 
    id: 5, 
    image: '/pexels-rezwan-1078884.jpg', 
    name: 'Commercial Buildings' 
  },
];

const Commodities = () => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false); 
    }, 2000);
    return () => clearTimeout(timer); 
  }, []);

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true, 
    });
  }, []);

  return (
    <>
      <Header />
      <br /><br /><br /><br />

      {isLoading ? (
        <Loader />  
      ) : (
        <>
          <section className="bg-gradient-to-r from-yellow-700 to-orange-600 text-white py-16">
            <div className="container mx-auto text-center px-6">
              <h1 className="text-3xl sm:text-4xl font-semibold mb-4" data-aos="fade-up">
                Building the Future, One Project at a Time
              </h1>
              <p className="text-lg sm:text-xl mb-8" data-aos="fade-up" data-aos-delay="200">
                We are a leading construction company specializing in infrastructure, residential, and commercial projects.
              </p>
              <div className="flex justify-center space-x-4 mb-12">
                <a href="/services">
                  <button className="btn px-6 py-3 bg-yellow-800 text-white font-semibold rounded-lg hover:bg-yellow-900 transition-transform">
                    Our Services
                  </button>
                </a>
                <a href="/contactus">
                  <button className="btn px-6 py-3 border-2 border-white text-white font-semibold rounded-lg hover:bg-orange-800 hover:text-yellow-100 transition-transform">
                    Get a Quote
                  </button>
                </a>
              </div>
              <img
                src="/logo.png"
                alt="Construction Company"
                className="mx-auto w-1/2 sm:w-1/3 h-auto rounded-lg mb-12 shadow-xl hover:shadow-2xl transition-all duration-300"
                data-aos="fade-up"
                data-aos-delay="400"
              />
            </div>
          </section>

          <section className="py-16 bg-white">
            <div className="container mx-auto text-center px-6">
              <h2 className="text-2xl sm:text-3xl font-semibold text-gray-900 mb-6" data-aos="fade-up" data-aos-delay="600">
                Our Featured Projects
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-8">
                {projects.map((project) => (
                  <div
                    key={project.id}
                    className="relative p-6 bg-yellow-100 rounded-lg shadow-lg transform transition-all hover:scale-105 hover:shadow-xl group"
                    data-aos="fade-up"
                    data-aos-delay={`${project.id * 200}`}
                  >
                    <div className="absolute inset-0 bg-black bg-opacity-50 blur-md opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                    <div className="cursor-pointer">
                      <img
                        src={project.image}
                        alt={project.name}
                        className="w-full h-48 sm:h-56 md:h-64 object-cover rounded-lg transition-transform duration-300 group-hover:scale-110"
                      />
                    </div>
                    <h3 className="font-semibold text-xl sm:text-2xl text-gray-800 mt-4">{project.name}</h3>
                  </div>
                ))}
              </div>
            </div>
          </section>

          <section className="bg-gradient-to-r from-orange-600 to-yellow-700 text-white py-12">
            <div className="container mx-auto text-center px-6">
              <p className="text-lg sm:text-xl text-white mt-12" data-aos="fade-up" data-aos-delay="1000">
                With decades of experience, we deliver excellence in every project. Let’s build something amazing together.
              </p>
            </div>
          </section>

          <Footer />
        </>
      )}
    </>
  );
};

export default Commodities;
